import { presenceInput } from '@scm-italy/presence-input';
import { getProfileTrustSettings, getTrustFeedbackUserToken } from '@sbt-web/network/client';

const getUserToken = async (hadesPublicBase) => {
    try {
        const { body } = await getTrustFeedbackUserToken(hadesPublicBase);
        return body.token;
    }
    catch {
        return '';
    }
};
const getSetting = async (profileApiUrl, userId, hadesPublicBase) => {
    const userToken = await getUserToken(hadesPublicBase);
    if (userToken) {
        try {
            const { body } = await getProfileTrustSettings(profileApiUrl, userId, userToken);
            return body;
        }
        catch {
            // nothing to do
        }
    }
};

const init = (presenceApiUrl, hadesPublicBase, userId, intervalTime) => {
    const DEFAULT_RETRY = 1000; // as milliseconds
    const settings = {
        apiUrl: presenceApiUrl,
        userId: `sdrn:subito:user:${userId}`,
        retry: {
            defaultTime: intervalTime || DEFAULT_RETRY,
        },
        getUserToken: () => getUserToken(hadesPublicBase),
    };
    presenceInput.init(settings);
};
/**
 * Pings the presence API for a user.
 *
 * @param profileApiUrl - trust presence API url (https://profile-api.trust-pre.mpi-internal.com || https://profile-api.trust-pro.mpi-internal.com)
 * @param presenceApiUrl - trust presence API url (https://presence-api.trust-pre.mpi-internal.com || https://presence-api.trust-pro.mpi-internal.com)
 * @param hadesPublicBase - hade public base url
 * @param userId - user id
 * @param checkSetting - set to true when consumer does not know if presence feature is enabled/disabled
 * @param intervalTime - amount of milleseconds for the next ping
 *
 * @example
 * ```ts
 * import { presencePing } from '@sbt-web/presence-ping';
 *
 * const params = {
 *   presenceApiUrl: 'https://presence-api.subito.it',
 *   profileApiUrl: 'https://profile-api.subito.it',
 *   hadesPublicBase: 'https://hades-public.subito.it',
 *   userId: '1234',
 *   checkSetting: true,
 *   intervalTime: 2000,
 * };
 *
 * presencePing(params);
 * ```
 */
const presencePing = async (presencePingParams) => {
    const { presenceApiUrl, profileApiUrl, hadesPublicBase, userId, checkSetting, intervalTime } = presencePingParams;
    if (checkSetting) {
        const setting = await getSetting(profileApiUrl, userId, hadesPublicBase);
        if (setting?.enabled) {
            init(presenceApiUrl, hadesPublicBase, userId, intervalTime);
        }
    }
    else {
        init(presenceApiUrl, hadesPublicBase, userId, intervalTime);
    }
};

export { presencePing };
//# sourceMappingURL=index.js.map
